// Angular Modules
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { LoadingService } from '@core/component/global-loading/loading.service';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    private _baseUrl: string = environment.apiUrl;

    constructor(
        private readonly _http: HttpClient,
        private readonly _router: Router,
        private readonly _loading: LoadingService
    ) {}

    public get(url: string, data?: any, shouldGetError?: boolean, options?: any): Observable<any> {
        return this.request('GET', url, shouldGetError, data, options);
    }

    public post(url: string, data: any, shouldGetError?: boolean, options?: any): Observable<any> {
        return this.request('POST', url, shouldGetError, data, options);
    }

    public put(url: string, data: any, shouldGetError?: boolean, options?: any): Observable<any> {
        return this.request('PUT', url, shouldGetError, data, options);
    }

    public patch(url: string, data: any, shouldGetError?: boolean, options?: any): Observable<any> {
        return this.request('PATCH', url, shouldGetError, data, options);
    }

    public delete(url: string, shouldGetError?: boolean, options?: any): Observable<any> {
        return this.request('DELETE', url, shouldGetError, undefined, options);
    }

    private request(
        method: string,
        url: string,
        shouldGetError = false,
        payload?: any,
        options: any = {}
    ): Observable<any> {
        this._loading.show();
        const subject = new Subject();
        url = `${this._baseUrl}/${url}`;

        options.headers = options.headers || {};

        if (url.includes('/storage/') && payload instanceof File) {
            options.body = payload;
        } else if (payload) {
            options.body = payload;
        }

        const request = this._http.request(method, url, options);
        request.subscribe({
            next: (response: any) => {
                if (response?.error_code) {
                    subject.error(response);
                    if (!shouldGetError) {
                        this.showError(response?.message);
                    }
                    return response;
                }
                this._loading.hide();
                subject.next(response);
                subject.complete();
                return response;
            },
            error: (error) => {
                this._loading.hide();
                console.error('Request error:', error);
                if (error?.status === 401) {
                    this._router.navigate(['/login']);
                }
                subject.error(error);
                if (!shouldGetError) {
                    this.showError(error.message || 'An error occurred');
                }
                return error;
            }
        });

        return subject.asObservable();
    }

    private showError(error: string) {
        console.error(error);
    }
}
